// Copyright (c) 2015, Frappe Technologies Pvt. Ltd. and Contributors
// MIT License. See license.txt

frappe.breadcrumbs = {
  all: {},

  preferred: {
    File: '',
    Dashboard: 'Customization',
    'Dashboard Chart': 'Customization',
    'Dashboard Chart Source': 'Customization',
  },

  module_map: {
    Core: 'Settings',
    Email: 'Settings',
    Custom: 'Settings',
    Workflow: 'Settings',
    Printing: 'Settings',
    Setup: 'Settings',
    'Event Streaming': 'Tools',
    Automation: 'Tools',
  },

  set_doctype_module(doctype, module) {
    localStorage['preferred_breadcrumbs:' + doctype] = module;
  },

  get_doctype_module(doctype) {
    return localStorage['preferred_breadcrumbs:' + doctype];
  },

  async add(module, doctype, type) {
    let obj;
    if (typeof module === 'object') {
      obj = module;
    } else {
      obj = {
        module: module,
        doctype: doctype,
        type: type,
      };
    }
    this.all[frappe.breadcrumbs.current_page()] = obj;
    await this.update();
  },

  current_page() {
    return frappe.get_route_str();
  },

  async update() {
    var breadcrumbs = this.all[frappe.breadcrumbs.current_page()];

    this.clear();
    if (!breadcrumbs) return this.toggle(false);

    if (breadcrumbs.type === 'Custom') {
      this.set_custom_breadcrumbs(breadcrumbs);
    } else {
      // workspace
      await this.set_workspace_breadcrumb(breadcrumbs);

      // form / print
      let view = frappe.get_route()[0];
      view = view ? view.toLowerCase() : null;
      if (!breadcrumbs.workspace) {
        this.clear();
      }
      if (this.$breadcrumbs.find('li').length > 2) {
        return;
      }
      if (breadcrumbs.doctype && ['print', 'form'].includes(view)) {
        this.set_list_breadcrumb(breadcrumbs);
        this.set_form_breadcrumb(breadcrumbs, view);
      } else if (breadcrumbs.doctype && view === 'list') {
        this.set_list_breadcrumb(breadcrumbs);
      } else if (breadcrumbs.doctype && view == 'dashboard-view') {
        this.set_list_breadcrumb(breadcrumbs);
        this.set_dashboard_breadcrumb(breadcrumbs);
      }
    }

    this.toggle(true);
  },

  set_custom_breadcrumbs(breadcrumbs) {
    const html = `<li><a href="${breadcrumbs.route}">${breadcrumbs.label}</a></li>`;
    this.$breadcrumbs.append(html);
  },

  get last_route() {
    return frappe.route_history.slice(-2)[0];
  },
  get last_workspace_route() {
    let workspaces = frappe.route_history.filter(
      (x) => x[0] && x[0] == 'Workspaces',
    );

    // console.log(workspaces)
    // if (workspaces.length) {
    let last_index = workspaces.length -1
    return workspaces[last_index] ? workspaces[last_index][1] : null;
    // }
  },

  async set_workspace_breadcrumb(breadcrumbs) {
    // get preferred module for breadcrumbs, based on history and module
    if (!breadcrumbs.workspace) {
      await this.set_workspace(breadcrumbs);
    }
    this.clear();
    if (!breadcrumbs.workspace) {
      return;
    }

    //

    if (
      breadcrumbs.module_info &&
      (breadcrumbs.module_info.blocked ||
        !frappe.visible_modules.includes(breadcrumbs.module_info.module))
    ) {
      return;
    }

    $(
      `<li><a href="/app/${frappe.router.slug(breadcrumbs.workspace)}">${__(
        breadcrumbs.workspace,
      )}</a></li>`,
    ).appendTo(this.$breadcrumbs);
  },

  async set_workspace(breadcrumbs) {
    // try and get module from doctype or other settings
    // then get the workspace for that module

    this.setup_modules();
    var from_module = this.get_doctype_module(breadcrumbs.doctype);

    if (from_module) {
      breadcrumbs.module = from_module;
    } else if (this.preferred[breadcrumbs.doctype] !== undefined) {
      // get preferred module for breadcrumbs
      breadcrumbs.module = this.preferred[breadcrumbs.doctype];
    }
    // debugger;
    let result = {};
    result = await frappe.call({
      method: 'erp_jordan.startup.boot.get_doctype_workspaces',
      args: {
        doctype: breadcrumbs.doctype,
        module: breadcrumbs.module,
      },
    });
    // console.log('result  ', result);
    let allowed_workspaces = result.message || [];

    // guess from last route
    if (this.last_route?.[0] == 'Workspaces') {
      // alert(this.last_route[1])
      let last_workspace = this.last_route[1];
      //   alert(allowed_workspaces.includses(last_workspace))
      if (
        (allowed_workspaces && allowed_workspaces.includes(last_workspace)) ||
        (breadcrumbs.module &&
          frappe.boot.module_wise_workspaces[breadcrumbs.module]?.includes(
            last_workspace,
          ))
      ) {
        breadcrumbs.workspace = last_workspace;
        // return;
      }
    }
    if (this.last_workspace_route && !breadcrumbs.workspace) {
      breadcrumbs.workspace = this.last_workspace_route;
    }

    if (breadcrumbs.module && !breadcrumbs.workspace) {
      if (this.module_map[breadcrumbs.module]) {
        breadcrumbs.module = this.module_map[breadcrumbs.module];
      }

      breadcrumbs.module_info = frappe.get_module(breadcrumbs.module);

      // set workspace
      if (
        breadcrumbs.module_info &&
        frappe.boot.module_wise_workspaces[breadcrumbs.module]
      ) {
        breadcrumbs.workspace =
          frappe.boot.module_wise_workspaces[breadcrumbs.module][0];
      }
    }
    // console.log(breadcrumbs.workspace , !allowed_workspaces.includes(breadcrumbs.workspace) , allowed_workspaces)
    if (
      // breadcrumbs.workspace &&
      allowed_workspaces &&
      // allowed_workspaces.length > 0 &&
      !allowed_workspaces.includes(breadcrumbs.workspace)
    ) {
      breadcrumbs.workspace = allowed_workspaces[0];
      // alert(allowed_workspaces[0])
    }
  },

  set_list_breadcrumb(breadcrumbs) {
    const doctype = breadcrumbs.doctype;
    const doctype_meta = frappe.get_doc('DocType', doctype);
    if (
      (doctype === 'User' && !frappe.user.has_role('System Manager')) ||
      doctype_meta?.issingle
    ) {
      // no user listview for non-system managers and single doctypes
    } else {
      let route;
      const doctype_route = frappe.router.slug(
        frappe.router.doctype_layout || doctype,
      );
      if (doctype_meta?.is_tree) {
        let view = frappe.model.user_settings[doctype].last_view || 'Tree';
        route = `${doctype_route}/view/${view}`;
      } else {
        route = doctype_route;
      }
      $(`<li><a href="/app/${route}">${__(doctype)}</a></li>`).appendTo(
        this.$breadcrumbs,
      );
    }
  },

  set_form_breadcrumb(breadcrumbs, view) {
    const doctype = breadcrumbs.doctype;
    const docname = frappe.get_route().slice(2).join('/');
    let doc_route_name = docname;
    let standard_name = doctype
      .toLowerCase()
      .replace(' ', '-')
      .replace(' ', '-');
    standard_name = `new-${standard_name}`;
    // alert(docname)
    // alert(standard_name)
    // alert(doctype)
    if (docname.includes(standard_name)) {
      let to_replace = __(`New ${doctype}`);
      // doc_route_name = docname.replace(standard_name, to_replace);
      doc_route_name = to_replace;
    }
    let form_route = `/app/${frappe.router.slug(doctype)}/${docname}`;
    $(`<li><a href="${form_route}">${__(doc_route_name)}</a></li>`).appendTo(
      this.$breadcrumbs,
    );

    if (view === 'form') {
      let last_crumb = this.$breadcrumbs.find('li').last();
      last_crumb.addClass('disabled');
      last_crumb.css('cursor', 'copy');
      last_crumb.click((event) => {
        event.stopImmediatePropagation();
        frappe.utils.copy_to_clipboard(last_crumb.text());
      });
    }
  },

  set_dashboard_breadcrumb(breadcrumbs) {
    const doctype = breadcrumbs.doctype;
    const docname = frappe.get_route()[1];
    let dashboard_route = `/app/${frappe.router.slug(doctype)}/${docname}`;
    $(`<li><a href="${dashboard_route}">${__(docname)}</a></li>`).appendTo(
      this.$breadcrumbs,
    );
  },

  setup_modules() {
    if (!frappe.visible_modules) {
      frappe.visible_modules = $.map(frappe.boot.allowed_workspaces, (m) => {
        return m.module;
      });
    }
  },

  async rename(doctype, old_name, new_name) {
    var old_route_str = ['Form', doctype, old_name].join('/');
    var new_route_str = ['Form', doctype, new_name].join('/');
    this.all[new_route_str] = this.all[old_route_str];
    delete frappe.breadcrumbs.all[old_route_str];
    await this.update();
  },

  clear() {
    this.$breadcrumbs = $('#navbar-breadcrumbs').empty();
  },

  toggle(show) {
    if (show) {
      $('body').addClass('no-breadcrumbs');
    } else {
      $('body').removeClass('no-breadcrumbs');
    }
  },
};
